import { render } from "./CommunityTrad.vue?vue&type=template&id=0804c517"
import script from "./CommunityTrad.vue?vue&type=script&lang=js"
export * from "./CommunityTrad.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__